'use client';

import BaseSpinner from '@module/components/Spinner/BaseSpinner';
import { useEmoticonFilterQuery } from '@module/queries/guide/useEmoticonFilterQuery/useEmoticonFilterQuery';
import { useEmoticonFilterStore } from '@module/stores/useEmoticonFilterStore';
import EmoticonListItem from '@pc/components/card/EmoticonListItem';
import BasePagenation from '@pc/components/pagenation/BasePagenation';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { keepPreviousData } from '@tanstack/react-query';
import { useState } from 'react';

const ITEMS_PER_PAGE = 15;

interface SignatureEmoticonListProps {
  filterType: 'all' | 'crew';
}

function SignatureEmoticonList({ filterType }: SignatureEmoticonListProps) {
  const page = useEmoticonFilterStore((state) => state.page);
  const setState = useEmoticonFilterStore((state) => state.setState);
  const [focusedIdx, setFocusedIdx] = useState<number | null>(null);

  const setPage = (newPage: number) => setState('page', newPage);

  const { queryResult } = useEmoticonFilterQuery({
    isInfinite: false,
    limit: ITEMS_PER_PAGE,
    type: 'signature',
    fixedFilterType: filterType,
    options: {
      placeholderData: keepPreviousData,
    },
  });

  const isLoading = queryResult.isLoading;
  const isListEmpty = !isLoading && !queryResult.data?.page.total;

  return (
    <>
      {isLoading && <BaseSpinner className='mx-auto my-20' />}
      {isListEmpty ? (
        <NotFoundDisplay text={'검색결과가 없습니다.'} className='pt-[65px] pb-0' />
      ) : (
        <div className='mt-8 grid min-h-[660px] w-[1360px] grid-cols-5'>
          {queryResult?.data?.list.map((item) => (
            <EmoticonListItem
              key={item.idx}
              item={item}
              onClick={() => setFocusedIdx(item.idx)}
              onBlur={() => setFocusedIdx(null)}
              isClicked={focusedIdx === item.idx}
            />
          ))}
        </div>
      )}

      <BasePagenation currentPage={page} setCurrentPage={setPage} pageData={queryResult.data?.page} />
    </>
  );
}

export default SignatureEmoticonList;
